import React from "react";
//outsource
import { Row, Col } from "antd";

//components
import ListItem from "./list_item";
import lodash from "lodash";
//redux
import { useDispatch, useSelector } from "react-redux";
import { allSelector } from "../../../store/group_service/group.selector";

const ListService = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const group = useSelector(allSelector);
  console.log({ group });
  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderItems = ({ key, item }) => {
    return (
      <Row style={{ width: "100%", margin: "40px 0px" }} key={key}>
        <ListItem data={item} />
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  const sorted = sortData(group);
  return (
    <Row style={{ width: "100%" }}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {sorted?.map((item, key) => renderItems({ key, item }))}
      </Col>
    </Row>
  );
};

export default ListService;

const sortData = (data) => {
  const newData = lodash.sortBy(data, ["name"]);
  return newData;
};
